/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import BusinessIcon from '@material-ui/icons/Business';
import classNames from 'classnames';
import React from 'react';
import compose from 'recompose/compose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import AccountDetailsPropTypes from './AccountDetails.component.props';
import accountDetailsStyles from './AccountDetails.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * AccountDetails
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const AccountDetailsComponent = ({ classes, account = {}, width }) => {
  const isSmDown = isWidthDown(`sm`, width);
  return (
    <div className={classes.marginBottom3unit}>
      <Grid container spacing={2}>
        {!isSmDown && (
          <Grid className={classes.iconContainer} item>
            <Avatar>
              <BusinessIcon />
            </Avatar>
          </Grid>
        )}
        <Grid className={classes.flexGrow1} item>
          <Typography variant="caption">Account Name</Typography>
          <Typography className={classes.subheading} variant="subtitle1" data-mf-replace-inner={MFSDR}>
            {account.AccountName}
          </Typography>
        </Grid>
      </Grid>
      <Grid className={classNames(!isSmDown && classes.iconSpacing)} container spacing={2}>
        {account.CustomerName && (
          <Grid item xs={12}>
            <Typography variant="caption">Customer Name</Typography>
            <Typography className={classes.subheading} variant="subtitle1" data-mf-replace-inner={MFSDR}>
              {account.CustomerName}
            </Typography>
          </Grid>
        )}
        {account.CustomerABN && (
          <Grid item md={3} sm={4} xs={12}>
            <Typography variant="caption">Customer ABN</Typography>
            <Typography className={classes.subheading} variant="subtitle1" data-mf-replace-inner={MFSDR}>
              {account.CustomerABN}
            </Typography>
          </Grid>
        )}
        {account.CustomerAccountCode && (
          <Grid item md={3} sm={4} xs={12}>
            <Typography variant="caption">Customer Account Code</Typography>
            <Typography className={classes.subheading} variant="subtitle1" data-mf-replace-inner={MFSDR}>
              {account.CustomerAccountCode}
            </Typography>
          </Grid>
        )}
        {account.CustomerCode && (
          <Grid item md={3} sm={4} xs={12}>
            <Typography variant="caption">Customer Code</Typography>
            <Typography className={classes.subheading} variant="subtitle1" data-mf-replace-inner={MFSDR}>
              {account.CustomerCode}
            </Typography>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

AccountDetailsComponent.propTypes = AccountDetailsPropTypes;

const AccountDetails = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(accountDetailsStyles), { withTheme: true }),
)(AccountDetailsComponent);

export default AccountDetails;
